import {
  PUSH_MESSAGE,
  CLEAR_MESSAGES,
  RESET_ERROR_MESSAGE_WITH,
  CLEAR_ERROR_MESSAGES,
  CLEAR_ONLY_ERROR_MESSAGES,
  TRY_AGAIN_CLICKED,
  REMOVE_SERVER_ERROR_MESSAGE,
  PUSH_SECTION_ERROR,
  CLEAR_SECTION_ERRORS,
  CLEAR_SECTION_ERRORS_AND_ERROR_MESSAGES,
  PUSH_SECTION_ERROR_TO_ERROR_MESSAGE,
  REMOVE_SINGLE_ERROR_MESSAGE,
  PUSH_PAGE_MESSAGES,
} from './messages-actions';

import { getRandomNumber } from '~/utils';
import { errors as errorTypes } from './messages.constants';

const { QUESTION_FIELD_ERROR } = errorTypes;

const initialState = {
  app: {
    messages: [],
    errorMessages: [],
    tryAgainClicked: false,
    sectionsErrors: [],
  },
  page: [],
};

const findByType = (messages, type) => messages.find((message) => message.type === type);
const removeQuestionMessages = (messages, questionId) =>
  messages.filter((element) => !element.endsWith(questionId));

const formatErrorsBySections = (errorsArray) =>
  errorsArray.reduce((acc, cur) => {
    const [section, error] = cur.split(':');
    return {
      ...acc,
      [section]: [...(acc[section] || []), error],
    };
  }, {});

const createErrorMessage = (type) => ({ type, id: getRandomNumber(0, 1000) });

const getErrorMessagesFromSection = (messages) =>
  Object.entries(formatErrorsBySections(messages)).map(([section, errors]) => {
    const fieldError = errors.find((el) => el.indexOf(QUESTION_FIELD_ERROR) !== -1);
    return createErrorMessage(`${section}:${fieldError || errors[0]}`);
  });

const clearErrorMessageIfSectionErrorsEmpty = (errorsMessages, sectionsMessages, payload) => {
  const sectionMessage = sectionsMessages.find((error) => error.indexOf(payload) !== -1);

  if (sectionMessage) {
    const [section, errorType] = sectionMessage.split(':');
    const errorTypeHead = `${section}:${errorType}`;
    const currentSectionErrors = sectionsMessages.filter((error) =>
      error.startsWith(errorTypeHead),
    );

    if (currentSectionErrors.length === 1) {
      return errorsMessages.filter((error) => !error.type.startsWith(errorTypeHead));
    }
  }

  return errorsMessages;
};

export const messagesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PUSH_MESSAGE:
      if (!findByType(state.app.messages, payload.type)) {
        return {
          ...state,
          app: {
            ...state.app,
            messages: [...state.app.messages, payload],
          },
        };
      }
      return state;
    case CLEAR_MESSAGES:
      return {
        ...state,
        app: {
          ...state.app,
          messages: [],
        },
      };
    case RESET_ERROR_MESSAGE_WITH:
      return {
        ...state,
        app: {
          ...state.app,
          errorMessages: payload,
        },
      };
    case CLEAR_ERROR_MESSAGES:
      return {
        ...state,
        app: {
          ...state.app,
          errorMessages: [],
          sectionsErrors: [],
        },
      };
    case CLEAR_ONLY_ERROR_MESSAGES:
      return {
        ...state,
        app: {
          ...state.app,
          errorMessages: [],
        },
      };
    case REMOVE_SINGLE_ERROR_MESSAGE: {
      const index = state.app.errorMessages.indexOf(findByType(state.app.errorMessages, payload));
      if (index !== -1) {
        const newMessages = [...state.app.errorMessages];
        newMessages.splice(index, 1);
        return {
          ...state,
          app: {
            ...state.app,
            errorMessages: newMessages,
          },
        };
      }
      return state;
    }
    case REMOVE_SERVER_ERROR_MESSAGE: {
      const index = state.app.errorMessages.findIndex((message) => message.url === payload);
      if (index !== -1) {
        const errorMessages = [
          ...state.app.errorMessages.slice(0, index),
          ...state.app.errorMessages.slice(index + 1),
        ];
        return {
          ...state,
          app: {
            ...state.app,
            errorMessages,
          },
        };
      }
      return state;
    }
    case TRY_AGAIN_CLICKED:
      return {
        ...state,
        app: {
          ...state.app,
          tryAgainClicked: payload,
          errorMessages: state.app.errorMessages.filter((item) => !item.url),
        },
      };
    case PUSH_SECTION_ERROR: {
      const formSectionName = payload.split(':')[2];
      const section = payload.split(':')[0];
      return {
        ...state,
        app: {
          ...state.app,
          sectionsErrors: [
            ...state.app.sectionsErrors.filter(
              (error) => !(error.startsWith(section) && error.endsWith(formSectionName)),
            ),
            payload,
          ],
        },
      };
    }
    case CLEAR_SECTION_ERRORS: {
      let newSectionsErrors;
      if (payload.indexOf(':') > -1) {
        const section = payload.split(':')[0];
        const formSectionName = payload.split(':')[1];
        newSectionsErrors = state.app.sectionsErrors.filter(
          (error) => !(error.startsWith(section) && error.endsWith(formSectionName)),
        );
      } else {
        newSectionsErrors = removeQuestionMessages(state.app.sectionsErrors, payload);
      }
      return {
        ...state,
        app: {
          ...state.app,
          sectionsErrors: newSectionsErrors,
        },
      };
    }
    case CLEAR_SECTION_ERRORS_AND_ERROR_MESSAGES:
      return {
        ...state,
        app: {
          ...state.app,
          errorMessages: clearErrorMessageIfSectionErrorsEmpty(
            state.app.errorMessages,
            state.app.sectionsErrors,
            payload,
          ),
          sectionsErrors: removeQuestionMessages(state.app.sectionsErrors, payload),
        },
      };
    case PUSH_SECTION_ERROR_TO_ERROR_MESSAGE:
      return {
        ...state,
        app: {
          ...state.app,
          errorMessages: getErrorMessagesFromSection(state.app.sectionsErrors),
        },
      };
    case PUSH_PAGE_MESSAGES:
      return {
        ...state,
        page: payload,
      };
    default:
      return state;
  }
};
